import React from 'react';
import { styled } from 'linaria/react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLongArrowLeft } from '@fortawesome/pro-light-svg-icons';

const BackArrowWrapper = styled.div`
  display: inline-block;
  margin-right: 1rem;
  a {
    display: flex;
  }
  svg {
    font-size: 2rem;
  }
`;

const BackArrow = ({ parents }) => {
  const parentPath =
    (parents && parents.length > 0 && parents[0].path) || false;

  if (!parentPath) return null;

  return (
    <BackArrowWrapper className="back-arrow">
      <Link to={parentPath}>
        <FontAwesomeIcon icon={faLongArrowLeft} />
      </Link>
    </BackArrowWrapper>
  );
};

export default BackArrow;
